import type { Fields } from '../types'
import { getFieldKeysForPreset } from './getFieldKeysForPreset'

export const createRepeaterNavMenuFieldMap = ({
  fields,
  pageLinkFieldKey,
}: {
  fields: Fields
  pageLinkFieldKey: string
}) => {
  const { titleFieldKey } = getFieldKeysForPreset(fields)
  return {
    title_fld: titleFieldKey,
    'link-categories-title_fld': pageLinkFieldKey,
  }
}

export const createCategoryRouterFieldMap = ({
  fields,
}: {
  fields: Fields
}) => {
  const {
    titleFieldKey,
    imageFieldKey,
    imagesAltTextFieldKey,
    shortDescriptionFieldKey,
    longDescriptionFieldKey,
  } = getFieldKeysForPreset(fields)
  return {
    description_fld: shortDescriptionFieldKey || longDescriptionFieldKey,
    title_fld: titleFieldKey,
    image_fld: imageFieldKey,
    imagealttext_fld: imagesAltTextFieldKey,
  }
}

export const createCategoryItemFieldMap = ({ fields }: { fields: Fields }) => {
  const {
    titleFieldKey,
    imageFieldKey,
    imagesAltTextFieldKey,
    shortDescriptionFieldKey,
    longDescriptionFieldKey,
  } = getFieldKeysForPreset(fields)

  return {
    itemName: titleFieldKey,
    itemDescription: shortDescriptionFieldKey || longDescriptionFieldKey,
    itemImage: imageFieldKey,
    imageAltText: imagesAltTextFieldKey,
  }
}
